import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../../hooks/useApi";
import { Textarea } from "../../../../../Input/Textarea";
import DefaultModalLayout from "../../../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { useSetRecoilState } from "recoil";
import { reportCompleteListState } from "../ReportComplete";
import { isNewChat } from "../../../../../../pages/Party/ChatInfo";

interface ChatReportRegisterModalProps {
  closeEvent: () => void;
  confirmEvent: () => void;
  chatKey: string;
}

export default function ChatReportRegisterModal({
  closeEvent,
  confirmEvent,
  chatKey,
}: ChatReportRegisterModalProps) {
  const [reason, setReason] = useState("");
  const [btnClick, setBtnClick] = useState(false);
  const setReportCompleteList = useSetRecoilState(reportCompleteListState);

  // 채팅 신고 처리하기
  const { response } = useApi({
    method: "post",
    url: btnClick ? `${isNewChat ? "chat" : "oldchat"}/report/comp` : undefined,
    data: {
      id: Number(chatKey),
      reason,
    },
  });

  // 신고 처리 완료 리스트 조회
  const { response: comResponse } = useApi({
    method: "get",
    url:
      response?.status === 201
        ? `${isNewChat ? "chat" : "oldchat"}/report?state=1&page=0&size=5`
        : ``,
  });

  console.log(response);

  useEffect(() => {
    if (response?.status === 201) {
    }
  }, [response]);

  useEffect(() => {
    if (comResponse?.status === 200) {
      setReportCompleteList(comResponse?.data?.items?.reverse());
      if (confirmEvent) {
        confirmEvent();
      }
      toast.success("채팅 신고 처리가 완료되었습니다.", {});
    }
  }, [comResponse]);

  return (
    <DefaultModalLayout
      isSmallModal={true}
      modalTitle="채팅 신고 접수"
      closeEvent={() => closeEvent()}
      confirmEvent={() => setBtnClick(true)}
      confirmBtnText="완료"
    >
      <DeleteModalLabel>처리 내용</DeleteModalLabel>

      <Textarea
        placeholder="삭제 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />
    </DefaultModalLayout>
  );
}
